import {FieldAddressAutocomplete} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {useAddressAutocomplete} from '../hooks';

import type {FieldAddressAutocompleteProps} from '@sollapay/ui/components';

/** `value` is the committed, Google-verified address — the only one a consuming form should submit. */
export interface AddressAutocompleteFieldProps extends Omit<
  FieldAddressAutocompleteProps,
  | 'inputValue'
  | 'onInputValueChange'
  | 'suggestions'
  | 'onSelectSuggestion'
  | 'loading'
  | 'errorText'
  | 'emptyText'
> {
  value: string;
  onChange: (address: string) => void;
}

/** Owns `useAddressAutocomplete` for the debounce/session-token/invalidate-on-edit wiring, plus the placeholder copy every address field uses. */
export function AddressAutocompleteField({
  value,
  onChange,
  placeholder,
  ...props
}: AddressAutocompleteFieldProps) {
  const {t} = useTranslation('common');
  const auto = useAddressAutocomplete(value, onChange);

  return (
    <FieldAddressAutocomplete
      placeholder={placeholder ?? t('addressAutocomplete.placeholder')}
      {...auto}
      {...props}
    />
  );
}
